import type { IPoiPendingImage } from '@/shared/api/types/poi-types'

/** URLs of images that uploaded successfully; errored or unfinished items are ignored when building a payload. */
export function successfulImageUrls(images: IPoiPendingImage[]): string[] {
  return images
    .filter((image) => image.status !== 'error' && image.url)
    .map((image) => image.url)
    .filter((url): url is string => Boolean(url))
}

export function hasUploadingImages(images: IPoiPendingImage[]): boolean {
  return images.some((image) => image.status === 'uploading')
}

export function hasErroredImages(images: IPoiPendingImage[]): boolean {
  return images.some((image) => image.status === 'error')
}
